module.exports = __webpack_public_path__ + "img/tema-3-4.320690ed.svg";